import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ReferralListComponent } from './components/referrals/referral-list/referral-list.component';
import { ReferralEditorComponent } from './components/referrals/referral-editor/referral-editor.component';
import { EncounterManagerComponent } from './components/encounter/encounter-manager/encounter-manager.component';
import { WorkbenchComponent } from './components/main/workbench/workbench.component';
import { EncounterBillingComponent } from './components/finance/encounter-billing/encounter-billing.component';
import { SettingsComponent } from './components/settings/settings.component';
import { EmailTemplatesManagerComponent } from './components/settings/email-templates-manager/email-templates-manager.component';
import { NotificationManagerComponent, DiaryManagerComponent, ProviderManagerComponent, TemplateEmails, dispatchActionsGuard } from '@harlowe/core';
import { MedicalBillProcessorComponent } from '@harlowe/core';

export const routes: Routes = 
[
    
    {
        path: '',
        redirectTo: 'Home',
        pathMatch: 'full',
    },
    {
        path: 'Home',
        component: WorkbenchComponent,
        canActivate: [MsalGuard, dispatchActionsGuard],
        data: {
            actions: [TemplateEmails.LoadEmailTemplates]
        }
    },
    {
        path: 'finance/encounter',
        component: EncounterBillingComponent,
        canActivate: [MsalGuard],
    },
    {
        path: 'referralManager',
        component: ReferralListComponent,
        canActivate: [MsalGuard],
        outlet: 'sidebar'
    },
    {
        path: 'encounterManager',
        component: EncounterManagerComponent,
        canActivate: [MsalGuard],
        outlet: "sidebar"
    },
    {
        path:'diaryManager',
        component: DiaryManagerComponent,
        canActivate: [MsalGuard],
        outlet: "sidebar"
    },
    {
        path: 'test',
        component: ReferralEditorComponent,
        canActivate: [MsalGuard],
        outlet: "sidebar"
    },
    {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [MsalGuard],
    },
    {
        path:'email_templates',
        component: EmailTemplatesManagerComponent,
        canActivate: [MsalGuard, dispatchActionsGuard],
        data: {
            actions: [TemplateEmails.LoadEmailTemplates]
        }
    },
    {
        path:'notifications',
        component: NotificationManagerComponent,
        canActivate: [MsalGuard],
    },
    {
        path: 'providers',
        component: ProviderManagerComponent,
        canActivate: [MsalGuard],
    }

];
